import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';

var Config = require('../../../config');

class ModalDetails extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			send_by:"",
			destiny_name:"",
			shipping_date:"",
			shipping_time:"",
			shipping_user:"",
			messenger:"",
			shipping_temp:"",
			shipping_observations:"",
			unitsAdded:[],


		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(id){
		this.props.waiting.handleShow('Cargando...');
		var user = JSON.parse(sessionStorage.getItem('medical_staff'));

		var name = ""
		if (user.names) {name += user.names};
		if (user.lastname1) {name += ' '+user.lastname1};
		if (user.lastname2) {name += ' '+user.lastname2};

		this.setState({
			shipping_user:  name,
			user_id:user.id,
		});	

		this.setState({
			send_by:sessionStorage.getItem("health_facilities_id"),
		});

		this.setState({confirm:true});
		fetch(Config.default.apiGateway.URL+'unit_transfer/'+id,{
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
			this.props.waiting.handleClose();
            if(res.ok){
              	return res.json();
            }else{
              	res.text().then(function(result) {
                	swal('¡Error', result, 'error');
              	});
            }})
		.then(response => {
			if(response !== undefined){
				this.setState({
					destiny_name:response.destiny,
					send_by:response.send_by,
					messenger: response.messenger,
					shipping_temp: response.shipping_temp,
					shipping_time: moment(response.shipping_time, 'H:mm:ss').format('HH:mm'),
					shipping_date:moment(response.shipping_date).format('YYYY-MM-DD'),
					shipping_user: response.user,
					shipping_observations:response.shipping_observations,
					unitsAdded:response.detail
				})

			}
		});	
		
		this.setState({show:true});
		
			
	}

	

	handleClose(){
		this.setState({show: false, table_required:[]});
	}

	render(){
		const {t} = this.props;
		return (
			<Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
							<div className="col-xs-12 col-sm-4">
								<span className="span-min">Centro Distribuidor</span>
								<input className="form-control" value={this.state.send_by} disabled/>
							</div>

							<div className="col-xs-12 col-sm-4">
								<span className="span-min">Centro Estatal</span>
						        <input name="destiny_name" value={this.state.destiny_name} disabled className="form-control" />
							</div>
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Fecha Envio</span>
								<input className="form-control hour-input" name="shipping_date" id="shipping_date" type="date" 
									value={this.state.shipping_date || ""} disabled />
							</div>
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Hora Envio</span>
								<input id="shipping_time" name="shipping_time" type="text" data-inputmask-alias="datetime" 
									data-inputmask-inputformat="HH:MM"  data-inputmask-placeholder="-" 
									value={this.state.shipping_time || ""} 
									disabled className="form-control"/>
							</div>
						</div>

						<div className="col-xs-12">
							<div className="col-xs-12 col-sm-4">
								<span className="span-min">Usuario Envía</span>
								<input className="form-control" disabled name="shipping_user" id="shipping_user" value={ this.state.shipping_user }/>
							</div>

							<div className="col-xs-12 col-sm-4">
								<span className="span-min">Mensajero</span>
								<input className="form-control" name="messenger" id="messenger" value={ this.state.messenger } disabled/>
							</div>
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Temperatura de Salida</span>
								<input className="form-control" name="shipping_temp" id="shipping_temp" 
									value={ this.state.shipping_temp }  disabled required/>
							</div>
						</div>
						<div className="col-xs-12">
							<div className="col-xs-12 col-sm-8">
								<span className="span-min">Observaciones</span>
								<textarea className="form-control" name="shipping_observations" value={ this.state.shipping_observations } 
									style={{resize:"none"}}  disabled/>
							</div>
						</div>
												
						<hr style={{width:'100%'}} />
						<fieldset>
							
							<div className="col-xs-12 form-group">
								<legend>{'Unidades enviar'}</legend>
								<div className="col-xs-12 col-sm-9">
									<Table responsive hover>
										<thead>
											<tr>
												<th>No. Donación</th>
												<th>Componente Sanguíneo</th>
												<th>No. Componente</th>
												<th>Grupo & RH</th>
												<th>Volumen</th>
												<th>Estatus</th>
											</tr>
										</thead>
										<tbody>
						                {this.state.unitsAdded.map( (unit, index) => (
						                    <tr key={index}>
						                      	<td>{unit.unit_number}</td>
						                      	<td>{unit.component}</td>
						                      	<td>{unit.component_number}</td>
						                      	<td>{unit.g_rh} </td>
						                      	<td>{unit.volume}</td>
						                      	<td>{unit.status}</td>
						                    </tr>
						                ))}
						               	
						                </tbody>
									</Table>
								</div>
								
							</div>
						</fieldset>
							
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>
		)
	}
}

export default translate('translations') (ModalDetails);
